module.exports = __webpack_public_path__ + "img/banner-42-dark.30cc4050.jpg";